import gql from "graphql-tag";

export const UPDATE_PAYMENT_METHOD = gql`
  mutation UpdatePaymentMethod($companyId: String!, $paymentMethod: PaymentMethodType!) {
    updatePaymentMethod(companyId: $companyId, paymentMethod: $paymentMethod) {
      result
    }
  }
`;
